import axios from "axios";
import { appConfigs } from "../../martin/_helpers";

export const ME_URL = "api/me";

export function login(email, password, captcha) {
  return axios.post(appConfigs.api_url + 'sign-in', { data: { email, password, captcha } });
}

export function register(email, name, password, captcha) {
  return axios.post(appConfigs.api_url + 'sign-up', { data: { email, name, password, captcha } });
}

export function requestPassword(email) {
  return axios.post(appConfigs.api_url + 'request-password', { email });
}

export function verifyUser(redirect_string) {
  return axios.post(appConfigs.api_url + 'get-user', { redirect_string });
}

export function getUserByToken() {
  return axios.post(appConfigs.api_url + 'get-user-by-token');
}

export function contactUs(email, name, message, captcha) {
  return axios.post(appConfigs.api_url + 'contact-us', { data: { email, name, message, captcha } });
}

export function updateUserProfile(user_hex, name, jwt) {
  return axios.post(appConfigs.api_url + 'update-user-profile', { data: { user_hex, name, jwt } });
}

export function changeUserPassword(user_hex, current_password, new_password, jwt) {
  return axios.post(appConfigs.api_url + 'change-password', { data: { user_hex, current_password, new_password, jwt } });
}
